import { z } from "zod";

// Helpers
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalBoolean = z.boolean().nullable().optional();

export const EnderecoSchema = z.object({
  // PK
  IdEndereco: z.number().int().default(0),

  // Campos de Texto
  Rua: optionalString.pipe(z.string().max(250, "Máximo de 250 caracteres").nullable().optional()),
  Numero: optionalString.pipe(z.string().max(10, "Máximo de 10 caracteres").nullable().optional()), // nchar(10)
  Apartamento: optionalString.pipe(z.string().max(100, "Máximo de 100 caracteres").nullable().optional()),
  Cep: optionalString.pipe(z.string().max(50, "Máximo de 50 caracteres").nullable().optional()), 
  Uf: optionalString.pipe(z.string().max(100, "Máximo de 100 caracteres").nullable().optional()),
  Cidade: optionalString.pipe(z.string().max(100, "Máximo de 100 caracteres").nullable().optional()),
  Bairro: optionalString.pipe(z.string().max(50, "Máximo de 50 caracteres").nullable().optional()),
  Pais: optionalString.pipe(z.string().max(150, "Máximo de 150 caracteres").nullable().optional()),

});

// Type inferido para formulários
export type EnderecoForm = z.infer<typeof EnderecoSchema>;